import { useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ModuleDashboardPage } from '../../../shared/components/index.js';
import { fetchReservationsDashboard } from '../services/reservationsService.js';

const SECTIONS = [
  { id: 'porEstado', chartKey: 'porEstado', title: 'Reservas por estado' },
  { id: 'porProyecto', chartKey: 'porProyecto', title: 'Reservas por proyecto' },
  { id: 'porEjecutivo', chartKey: 'porEjecutivo', title: 'Reservas por ejecutivo' },
  { id: 'evolucion', chartKey: 'evolucion', title: 'Evolución mensual' },
  { id: 'monto', chartKey: 'monto', title: 'Monto reservado por período' },
  { id: 'porVencer', chartKey: 'porVencer', title: 'Reservas próximas a vencer' },
  { id: 'alertas', type: 'alerts', title: 'Alertas de reservas' },
  { id: 'tabla', type: 'table', title: 'Reservas' }
];

export default function ReservasPage() {
  const { email } = useOutletContext() || {};
  const loadData = useCallback((f) => fetchReservationsDashboard(f), []);
  return (
    <ModuleDashboardPage
      title="Reservas"
      subtitle="Control de reservas inmobiliarias. Mercado Pago / Reservas_Automaticas: pendiente."
      email={email}
      loadData={loadData}
      filterOpts={{ showStatus: true }}
      sections={SECTIONS}
    />
  );
}
